var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/ui-config.ts
import { setCustomAssets } from "@leagueplatform/asset-config";
var uiConfig = null;
function setInitialUiConfig(config) {
  if (!config)
    throw new Error("You must provide a UI config");
  if (config.assets) {
    setCustomAssets(config.assets);
  }
  uiConfig = config;
}
function getInitialUiConfig() {
  if (!uiConfig)
    throw new Error("UI configuration is not defined.");
  return uiConfig;
}

// src/league-theme-provider/league-ui-config-provider.tsx
import React, { createContext, useState, useMemo } from "react";
import { archetypeLightTheme } from "@leagueplatform/genesis-core";
var UiConfigContext = createContext([
  { theme: archetypeLightTheme },
  () => {
  }
]);
var LeagueUIConfigProvider = ({ children }) => {
  const [uiConfig2, setUiConfig] = useState(getInitialUiConfig);
  const contextValue = useMemo(
    () => [uiConfig2, setUiConfig],
    [uiConfig2]
  );
  return /* @__PURE__ */ React.createElement(UiConfigContext.Provider, { value: contextValue }, children);
};

// src/hooks/use-ui-config.ts
import { useContext } from "react";
var useUiConfig = () => useContext(UiConfigContext);

// src/hooks/use-ui-config-theme.ts
import { useCallback } from "react";
function useUiConfigTheme() {
  const [uiConfig2, setUiConfig] = useUiConfig();
  const setTheme = useCallback(
    (theme) => {
      setUiConfig(__spreadProps(__spreadValues({}, uiConfig2), { theme }));
    },
    [uiConfig2, setUiConfig]
  );
  return { theme: uiConfig2.theme, setTheme };
}

// src/hooks/use-color-scheme.ts
import { useState as useState2, useCallback as useCallback2, useEffect } from "react";
function useColorScheme({
  themes,
  initialColorScheme
}) {
  const { theme: uiConfigTheme, setTheme } = useUiConfigTheme();
  const [colorScheme, setColorScheme] = useState2(() => {
    if (!initialColorScheme) {
      const initialUiConfigColorScheme = Object.keys(themes).find((key) => {
        const themeForKey = themes[key];
        return themeForKey === uiConfigTheme;
      });
      const mql = window.matchMedia("(prefers-color-scheme: light)");
      return (initialUiConfigColorScheme != null ? initialUiConfigColorScheme : mql.matches) ? "light" : "dark";
    }
    return initialColorScheme;
  });
  const setThemeForColorScheme = useCallback2(
    (newColorScheme) => {
      const theme = themes[newColorScheme];
      if (theme) {
        setTheme(theme);
        setColorScheme(newColorScheme);
      }
    },
    [themes, setTheme]
  );
  useEffect(() => {
    const onPrefersColorSchemeChange = (event) => {
      const nextColorScheme = event.matches ? "light" : "dark";
      setThemeForColorScheme(nextColorScheme);
    };
    const mql = window.matchMedia("(prefers-color-scheme: light)");
    mql.addEventListener("change", onPrefersColorSchemeChange);
    return () => mql.removeEventListener("change", onPrefersColorSchemeChange);
  }, [setThemeForColorScheme]);
  const toggleColorScheme = () => {
    const nextColorScheme = colorScheme === "light" ? "dark" : "light";
    setThemeForColorScheme(nextColorScheme);
  };
  return {
    theme: themes[colorScheme],
    colorScheme,
    setThemeForColorScheme,
    toggleColorScheme
  };
}
export {
  LeagueUIConfigProvider,
  getInitialUiConfig,
  setInitialUiConfig,
  useColorScheme,
  useUiConfig,
  useUiConfigTheme
};
//# sourceMappingURL=index.js.map